import { ListPlanRequestDTO } from '../../dtos/ListPlanRequestDTO';
import { ListPlanResponseDTO } from '../../dtos/ListPlanResponseDTO';
import { api } from '../api';

export const listPlanService = async ({
  skip,
  take,
}: ListPlanRequestDTO): Promise<ListPlanResponseDTO> => {
  const { data } = await api.get('/plans', {
    params: { skip, take },
  });

  return data;
};
